<template>
    <div
      v-if="visible"
      class="base-sidebar omnica-modal-sidebar-overlay"
      @click.self="close"
    >
      <!-- Анимация для выезда sidebar -->
      <transition name="sidebar-slide">
        <aside class="omnica-modal-sidebar omnica-modal-sidebar_size_lg" v-if="visible">
          <!-- Заголовок -->
          <header class="omnica-modal-sidebar__header">
            <div class="omnica-modal-sidebar__header-inner">
              <div class="omnica-modal-sidebar__title">
                <div class="sidebar-head__title">
                  Редактирование задачи
                  <span>к заказу  
                    <span v-if="taskorder"> {{ taskorder }}</span> 
                    <span v-else>{{ orderId }}</span>
                  </span> 
                  
                </div>
                
              </div>
              <button
                role="button"
                aria-label="Esc"
                class="omnica-modal-sidebar__close"
                @click="close"
              >
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="32" class="omnica-popper-target"><path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg>
              </button>
            </div>
          </header>
  
          <!-- Основное содержание -->
          <div class="omnica-modal-sidebar__body">
            <div >
              <!-- Поле "Что сделать?" -->
              <div class="sidebar-form__item">
                <label for="taskText" class="sidebar-form__label">Что сделать?</label>
                
                <div v-if="tasktext">
                  <input
                    id="taskText"
                    type="text"
                    v-model="tasktext"
                    class="UiInput-input__area-2i6h"
                  
                  />
                </div>
                <div v-else>
                  <input
                    id="taskText"
                    type="text"
                    v-model="formData.taskText"
                    class="UiInput-input__area-2i6h"
                  
                  />
                </div>


              </div>
  
              <!-- Поле "Теги" -->
              <div class="sidebar-form__item">
                <label for="tags" class="sidebar-form__label">Теги</label>
                <input
                  id="tags"
                  type="text"
                  v-model="formData.tags"
                  class="UiInput-input__area-2i6h"
                  placeholder="Введите теги через запятую"
                />
              </div>
  
              <!-- Поле "Срок исполнения" -->
              <div class="sidebar-form__item">
                <label for="dueDate" class="sidebar-form__label">Срок исполнения</label>
                <div class="sidebar-form__row">
                  <!-- Выбор даты для календаря-->

                   <div v-if="duedata">
                      <flat-pickr
                      v-model="duedata"
                      :config="flatpickrConfig"
                      class="flatpickr"
                      placeholder="Выберите дату и время"
                    />
                   </div>
                   <!-- для orderEdit -->
                   <div v-else>
                    <flat-pickr
                    v-model="formData.dueDate"
                    :config="flatpickrConfig"
                    class="flatpickr"
                    placeholder="Выберите дату и время"
                  />
                   </div>

                </div>
              </div>
  
              <!-- Поле "Описание" -->
              <div class="sidebar-form__item ">
                <label for="description" class="sidebar-form__label">Описание</label>
                <div class="UiTextarea-textarea_default-26FY">
                  <div v-if="description">
                      <textarea
                    id="description"
                    v-model="description"
                    rows="3"
                    class="UiTextarea-textarea__area-1IwX"
                  ></textarea>
                  </div>

                  <div v-else>
                    <textarea
                      id="description"
                      v-model="formData.description"
                      rows="3"
                      class="UiTextarea-textarea__area-1IwX"
                    ></textarea>
                  </div>

                </div>
              </div>
  
              <!-- Поле "Ответственный" -->
              <div class="sidebar-form__item">
                <label for="performer" class="sidebar-form__label">Ответственный</label>
                
                <div v-if="performer">
                  <v-select
                    :options="managers"
                    label="label"
                    v-model="performer"
                    placeholder="Выберите менеджера"
                    class="v-select"
                    :reduce="manager => manager.retailCrmId"
                  />
                </div>
                <div v-else>
                  <v-select
                    :options="managers"
                    label="label"
                    v-model="formData.performer"
                    placeholder="Выберите менеджера"
                    class="v-select"
                    :reduce="manager => manager.retailCrmId"
                  />
                </div>


              </div>
              
              <!-- Кнопки -->
  
            </div>
          </div>
           <footer class="omnica-modal-sidebar__footer">
                <button
                  type="button"
                  class="omnica-button omnica-button_secondary omnica-button_sm omnica-button_default omnica-button_ellipsis"
                  @click="close"
                >
                  Закрыть
                </button>
                <!-- для календаря -->
                <span v-if="taskid">
                  <button type="submit"  @click="updateTaskField(taskid, performer, duedata, description, taskorder, taskorderid, tasktext )" class="mr-4 omnica-button omnica-button_primary omnica-button_sm omnica-button_default omnica-button_ellipsis">
                    Сохранить
                  </button>
                </span>
                <!-- для orderEdit -->
                <span v-else>
                  <button type="submit"  @click="updateTaskField(editTaskid, formData.performer, formData.dueDate, formData.description, orderId, $route.params.orderId, formData.taskText )" class="mr-4 omnica-button omnica-button_primary omnica-button_sm omnica-button_default omnica-button_ellipsis">
                    Сохранить 
                  </button>
                </span>

              </footer>
        </aside>
      </transition>
    </div>
  </template>
  
  <script>
  import axios from 'axios';    
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import { Russian } from "flatpickr/dist/l10n/ru.js";
  import vSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';
  
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
      orderId: {
        type: String,
        required: false,
        default: "",
      },
      editTaskid: {
        type: String,
        required: false,
        default: "",
      },
      idOrder: {
        type: String, 
        required: false
      },
      taskid:{
        type: String, 
        required: false
      },
      duedata: {
        type: String,
        required: false
      },
      tasktext: {
        type: String,
        required: false 
      },
      description: {
        type: String,
        required: false 
      },
      performer: {
        type: String,
        required: false
      },
      taskorder: {
        type: String,
        required: false
      },
      taskorderid: {
        type: String,
        required: false
      },
      managers: {
        type: Array,
        required: true, // Передаем массив менеджеров из основного приложения
      }
    },
    components: {
      flatPickr,
      vSelect,
          },
    data() {
      return {
        formData: {
          taskOrder:"",
          taskText: "",
          tags: "",
          dueDate: "",
          dueTime: "",
          description: "",
          taskid: ""
        },
        flatpickrConfig: {
          locale: Russian, // Русификация
          enableTime: true, // Включаем выбор времени
          dateFormat: "d.m.Y H:i", // Формат даты
          time_24hr: true, // 24-часовой формат времени
        },
      };
    },
    
  
    watch:{
      async editTaskid(editTaskid) {
        console.log('запустил: editTaskid');
        const orderid = this.$route.params.orderId;
        try {
        const response = await fetch(`https://manager.1akb.by/getTasksByOrderIds?taskOrderId=${orderid}&id=${editTaskid}`);

        if (!response.ok) {
          throw new Error(`Ошибка: ${response.statusText}`);
        } 

        const tasks = await response.json();

        //подставляю данные 
        
        //this.formData.taskText = taskTit;

        // const dueDat = JSON.parse(tasks.dueDate);
        // this.formData.dueDate = dueDat.value;
        //подставляю менеджера
        const performerData = JSON.parse(tasks.performer);
        this.formData.performer = performerData.value; 

        this.formData.taskText = tasks.taskText;
        this.formData.description = tasks.description;
        this.formData.dueDate = tasks.dueDate;


      } catch (error) {
        console.error("Ошибка при получении задач:", error);
      }
      },
    },
    methods: {
      
      getOptionObject(optionsArray, id) {
        const option = optionsArray.find(option => option.retailCrmId === id);
        return option ? { label: option.label, value: option.retailCrmId } : null;
      },
      close() {
        this.$emit("close");
      },
  
      // user_select() {
      //   // Установим id текущего пользователя в поле performer
      //   const currentUser = this.$store.state.user;
      //   if (currentUser && currentUser.id) {
      //     this.formData.performer = currentUser.id;
      //   }
      // },
      user_select() {
      // Установим id текущего пользователя в поле performer
        const currentUser = this.$store.state.user;
        if (currentUser && currentUser.retailCrmId) {
          this.formData.performer = currentUser.retailCrmId;
        }
    },

    async updateTaskField(editTaskid, performer, duedata, description, taskorder, taskorderid, tasktext) {
      try {
        const managerObj = this.managers.find(manager => manager.retailCrmId === performer);

        const userId = {
          label: managerObj.label,
          value: performer
        };

        const userIdjson = JSON.stringify(userId);

        const dataToSend = {
          description: description,
          dueDate: duedata,
          id: editTaskid,
          taskOrder: taskorder,
          taskOrderId: taskorderid,
          performer: userIdjson,
          taskText: tasktext
        };

        console.log(dataToSend);

        const response = await axios.post('https://manager.1akb.by/updateTaskFields', dataToSend);
        console.log('Response from server:', response.data);

        this.close();
      } catch (error) {
        console.error('Error while submitting form:', error);
      }
    },

      close() {
          this.$emit("close");
      }
      
    },
    
  };
  </script>
  
  <style scoped>
  /* Задний фон */
  .base-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(45,51,108,.4);
    display: flex;
    justify-content: flex-end;
    z-index: 1000;
  }
  
  /* Сайдбар */
  .omnica-modal-sidebar {
    width: 400px;
    background: #fff;
    display: flex;
    flex-direction: column;
    /*transform: translateX(100%);*/ /* Исходное положение - за экраном */
  }
  
  
  
  .omnica-modal-sidebar {
      background: #fff;
      bottom: 0;
      box-shadow: 0 8px 16px rgb(30 34 72 / 16%);
      display: flex;
      flex-direction: column;
      height: 100%;
      left: auto;
      position: absolute;
      right: 0;
      top: 0;
      width: 416px;
  }
  
  
  .omnica-modal-sidebar_size_lg {
      width: 720px;
  }
  
  
  
  .omnica-modal-sidebar__header {
      align-items: center;
      border-bottom: 1px solid #dee2e6;
      display: flex;
      flex: 0 1 68px;
      justify-content: space-between;
      min-height: 68px;
      padding: 0 24px 0 32px;
      position: relative;
  }
  
  .omnica-modal-sidebar__body {
      flex: 1;
      overflow-y: auto;
      padding: 24px 32px;
  }
  
  .omnica-modal-sidebar__header-inner {
      align-items: center;
      display: flex;
      min-width: 0;
      padding-right: 16px;
  }
  
  .omnica-modal-sidebar__title {
      color: #0d0f1f;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.33333333;
  }
  
  .sidebar-head {
      align-items: center;
      display: flex;
  }
  
  .sidebar-head__title {
      overflow: hidden;
      text-overflow: ellipsis;
  }
  
  .omnica-modal-sidebar__close {
      color: #afb9c3;
      cursor: pointer;
      height: 32px;
      position: absolute;
      right: 17px;
      top: 18px;
      transition: color .25s ease;
      width: 32px;
      background: transparent;
      border: 0px;
  }
  
  
  
  .ps {
      -ms-overflow-style: none;
      overflow: hidden!important;
      overflow-anchor: none;
      touch-action: auto;
      -ms-touch-action: auto;
  }
  
  .ps, .ps * {
      box-sizing: border-box;
  }
  
  .ps {
      position: relative;
  }
  
  .omnica-modal-sidebar__footer {
      background: #f9fafb;
      min-height: 80px;
      padding: 22px 32px;
  }
  
  .sidebar-form__item:first-child {
      margin-top: 0;
  }
  
  .sidebar-form__label {
      color: #8a96a6;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 1.42857143;
      margin-bottom: 4px;
  }
  
  .UiInput-input-3imQ {
      align-items: center;
      display: flex;
      transition: .25s ease;
  }
  
  
  .UiInput-input__area-2i6h {
      background: #fff;
      border: 1px solid #dee2e6;
      border-radius: 6px;
      position: relative;
      width: 100%;
  }
  
  .UiInput-input__area-2i6h {
      height: 36px;
      padding: 0 10px;
  }
  
  .UiTextarea-textarea_default-26FY {
      border: 1px solid #dee2e6;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      min-height: 96px;
  }
  
  .UiTextarea-textarea__area-1IwX {
    background: #fff!important;
      border-radius: 6px!important;
      color: #1e2248!important;
      padding: 8px 16px!important;
  }
  
  
  .omnica-modal-sidebar__close:hover {
      color: #636f7f;
  }
  
  
  .datepicker,
  .timepicker {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
  }
  
  .omnica-button {
      --omnica-button-text-color: #1e2248;
      appearance: none;
      background-image: none;
      border: none;
      border-radius: 6px;
      box-sizing: border-box;
      color: var(--omnica-button-text-color);
      cursor: pointer;
      display: inline-block;
      font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Roboto,sans-serif;
      line-height: normal;
      padding: 0 20px;
      text-align: center;
      text-decoration: none;
      touch-action: manipulation;
      transition: color .25s ease,background .25s ease,box-shadow .25s ease,border .25s ease,width 0s;
      user-select: none;
      vertical-align: top;
      white-space: nowrap;
  }
  
  .omnica-button_primary {
      --omnica-button-background-color: #005eeb;
      --omnica-button-background-color-active: #0052cc;
      --omnica-button-background-color-disabled: #b8dbff;
      --omnica-button-background-image: linear-gradient(180deg,#0068ff,#005bd5);
      --omnica-button-text-color: #fff;
      background-color: var(--omnica-button-background-color);
      background-image: var(--omnica-button-background-image);
      font-weight: 500;
      margin-left: 10px;
      color: #fff;
  }
  .omnica-button, .omnica-button:active, .omnica-button:focus {
      box-shadow: none;
      outline: none!important;
  }
  .omnica-button_secondary {
      background-color: #f4f6f8;
      background-image: linear-gradient(180deg,#fff,#e9ecee);
      border: 1px solid #dee2e6;
  }
  
  .omnica-button_sm {
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      height: 36px;
      line-height: normal;
      min-width: 96px;
      padding: 0 20px;
  }
  .omnica-button__inner {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      width: 100%;
  }
  
  .omnica-button_ellipsis .omnica-button__text {
      overflow: hidden;
      text-overflow: ellipsis;
  }
  
  .flatpickr {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
  }
  
  
  /* Анимация для выезда */
  .sidebar-slide-enter-active,
  .sidebar-slide-leave-active {
    transition: transform 0.3s ease-out;
  }
  
  .sidebar-slide-enter-from,
  .sidebar-slide-leave-to {
    transform: translateX(100%); /* Скрытое положение */
  }
  
  .sidebar-slide-enter-to,
  .sidebar-slide-leave-from {
    transform: translateX(0); /* Позиция видна */
  }
  </style>
  